import React from "react";
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/system";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

const StyledIconButton = styled(IconButton)(({ theme }) => ({
  width: "100%",
  height: "100%",
  backgroundColor: theme.palette.primary.main,
  color: "#fff",
  "&:hover": {
    backgroundColor: theme.palette.primary.dark,
  },
  boxShadow: "0px 4px 5px rgba(0, 0, 0, 0.1)",
  borderRadius: "50%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
}));

const CustomIconButton = ({ onClick, customIcon, text }) => {
  return (
    <Box
      sx={{
        width: "15vw", // 20% of the viewport width
        maxWidth: "100px", // Set a max width to ensure it doesn't get too large
        height: "15vw", // Maintain a square aspect ratio
        maxHeight: "100px", // Set a max height to ensure it doesn't get too large
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <StyledIconButton onClick={onClick}>
        <Box component="img" src={customIcon} sx={{ width: "70%", height: "70%" }} />
      </StyledIconButton>
      <Typography
        fontWeight={550}
        fontSize={'large'}
        textAlign="center"
        sx={{ mt: "2px",fontSize:"12pt", color: "#000", whiteSpace: "nowrap" }}
      >
        {text}
      </Typography>
    </Box>
  );
};

export default CustomIconButton;
